module.exports = __webpack_public_path__ + "img/icon64.f47bdeed.png";